import { render, staticRenderFns } from "./cus-header.vue?vue&type=template&id=511625da&scoped=true"
import script from "./cus-header.vue?vue&type=script&lang=js"
export * from "./cus-header.vue?vue&type=script&lang=js"
import style0 from "./cus-header.vue?vue&type=style&index=0&id=511625da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511625da",
  null
  
)

export default component.exports